export default "__VITE_ASSET__bfrCQRWC__"